/**
 * Dev-only logger. In production these are no-ops, keeping the console clean
 * and avoiding any debug info leaking to end users.
 *
 * The `console.*` calls below are intentional and guarded by NODE_ENV — they
 * are this module's job, so we explicitly disable the no-console rule here.
 */
/* eslint-disable no-console */
const IS_DEV = process.env.NODE_ENV !== 'production';

export const log = (...args) => {
  if (IS_DEV) console.log(...args);
};

export const warn = (...args) => {
  if (IS_DEV) console.warn(...args);
};

export const error = (...args) => {
  if (IS_DEV) console.error(...args);
};

const logger = { log, warn, error };
export default logger;
